<template>
  <div class="resource-form-page">
    <van-nav-bar
      :title="isEdit ? '编辑资源' : '新建资源'"
      left-arrow fixed placeholder
      @click-left="$router.back()"
    />
    <div class="form-wrap">
      <!-- Cover image upload -->
      <div class="upload-section">
        <div class="section-label">封面图片</div>
        <van-uploader
          :after-read="onCoverUpload"
          :max-count="1"
          :deletable="true"
          v-model="coverList"
          accept="image/*"
          :preview-full-image="true"
        >
          <template #default>
            <div class="upload-box">
              <van-icon name="photograph" size="28" color="#a5b4fc" />
              <span>上传封面</span>
            </div>
          </template>
        </van-uploader>
      </div>

      <van-form @submit="onSubmit">
        <div class="form-card">
          <van-field
            v-model="form.title"
            label="标题"
            placeholder="请输入资源标题"
            :rules="[{ required: true, message: '请输入标题' }]"
            maxlength="100"
          />
          <van-field
            v-model="form.description"
            label="描述"
            placeholder="资源描述（选填）"
            type="textarea"
            rows="3"
            maxlength="500"
            show-word-limit
          />
          <van-field
            v-model="form.driveUrl"
            label="网盘链接"
            placeholder="请输入网盘链接"
            :rules="[{ required: true, message: '请输入网盘链接' }]"
          />
          <van-field
            v-model="form.extractCode"
            label="提取码"
            placeholder="请输入提取码"
            :rules="[{ required: true, message: '请输入提取码' }]"
          />
        </div>

        <div class="form-card">
          <van-cell title="付费资源" center>
            <template #right-icon>
              <van-switch v-model="form.isPaid" size="24" active-color="#6366f1" />
            </template>
          </van-cell>
          <van-field
            v-if="form.isPaid"
            v-model.number="form.price"
            label="价格"
            placeholder="请输入金额"
            type="number"
            :rules="[{ required: true, message: '请输入价格' }]"
          >
            <template #left-icon>¥</template>
          </van-field>
        </div>

        <div class="submit-wrap">
          <van-button
            round block
            native-type="submit"
            :loading="submitting"
            color="linear-gradient(135deg, #6366f1, #8b5cf6)"
          >
            {{ isEdit ? '保存修改' : '发布资源' }}
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { resourceApi, uploadApi } from '../api';

export default {
  data() {
    return {
      isEdit: false,
      resourceId: null,
      coverList: [],
      form: {
        title: '', description: '', coverUrl: '', driveUrl: '',
        extractCode: '', isPaid: false, price: 0
      },
      submitting: false,
      loading: false
    };
  },
  created() {
    if (this.$route.params.id) {
      this.isEdit = true;
      this.resourceId = parseInt(this.$route.params.id);
      this.loadResource();
    }
  },
  methods: {
    async loadResource() {
      this.loading = true;
      try {
        const res = await resourceApi.getById(this.resourceId);
        const r = res.data;
        this.form = {
          title: r.title || '',
          description: r.description || '',
          coverUrl: r.coverUrl || '',
          driveUrl: r.driveUrl || '',
          extractCode: r.extractCode || '',
          isPaid: !!r.isPaid,
          price: r.price || 0
        };
        if (r.coverUrl) {
          this.coverList = [{ url: r.coverUrl, isImage: true }];
        }
      } catch (e) {
        this.$toast.fail('加载资源失败');
        this.$router.back();
      } finally {
        this.loading = false;
      }
    },
    async onCoverUpload(file) {
      this.$toast.loading({ message: '上传中...', forbidClick: true, duration: 0 });
      try {
        const res = await uploadApi.upload(file.file);
        this.form.coverUrl = res.data.url;
        this.$toast.clear();
        this.$toast.success('上传成功');
      } catch (e) {
        this.$toast.clear();
        this.coverList = [];
      }
    },
    async onSubmit() {
      this.submitting = true;
      try {
        if (this.isEdit) {
          await resourceApi.update(this.resourceId, this.form);
          this.$toast.success('更新成功');
        } else {
          await resourceApi.create(this.form);
          this.$toast.success('发布成功');
        }
        this.$router.back();
      } catch (e) {
        /* handled by interceptor */
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.resource-form-page {
  min-height: 100vh; background: #f5f7fa;
}
.form-wrap {
  padding: 12px 16px 40px;
}
.upload-section {
  margin-bottom: 12px;
}
.section-label {
  font-size: 14px; font-weight: 500; color: #374151;
  margin-bottom: 8px; padding-left: 4px;
}
.upload-box {
  width: 88px; height: 88px; border-radius: 8px;
  border: 2px dashed #c7d2fe;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  background: #eef2ff; gap: 4px;
}
.upload-box span {
  font-size: 11px; color: #818cf8;
}
.form-card {
  background: #fff; border-radius: 12px;
  overflow: hidden; margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.submit-wrap {
  margin-top: 24px; padding: 0 8px;
}
</style>
